<template>
  <v-app id="calapp">
    <v-container
      fluid
      class="expert-cal-wrapper"
    >
      <v-row dense>
        <v-col
          cols="12"
          lg="3"
        >
          <v-col cols="12">
            <v-date-picker
              v-model="focus"
              full-width
              elevation="1"
              :events="arrayEvents"
              event-color="green lighten-1"
            />
          </v-col>
          <v-spacer height="60px" />
          <v-col cols="12">
            <v-tabs
              v-model="tab"
              center-active
              fixed-tabs
            >
              <v-tabs-slider />
              <v-tab
                v-for="(name, index) in tabs"
                :key="index"
                :href="`#tab-${index}`"
                @change="getTabName(name)"
              >
                {{ name }}
              </v-tab>

              <v-tab-item
                v-for="(name, i) in tabs"
                :key="i"
                class="overflow-y-auto"
                style="max-height: 835px;"
                :value="'tab-' + i"
              >
                <v-dialog
                  v-model="selectedOpenSummary"
                  width="400"
                >
                  <template #activator="{ on, attrs }">
                    <v-container v-if="i == 0">
                      <v-row dense>
                        <v-col
                          v-for="(item, index) in sideEventsComputed"
                          :key="index"
                          cols="12"
                        >
                          <v-card
                            v-bind="attrs"
                            class="primary theme--dark"
                            v-on="on"
                            @click="showEventSummary(item)"
                          >
                            <v-card-title v-text="item.name" />
                            <v-card-subtitle v-html="toDateWithTz(item.start) + '  to  ' + toDateWithTz(item.end, item.isMidnight)" />
                            <v-card-subtitle v-html="eventDuration(item.start, item.end, item.isMidnight)" />
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-container>

                    <v-container v-if="i == 1">
                      <v-row dense>
                        <v-col
                          v-for="(item, index) in sideEventsComputed"
                          :key="index"
                          cols="12"
                        >
                          <v-card
                            v-bind="attrs"
                            class="yellow theme--light"
                            v-on="on"
                            @click="showEventSummary(item)"
                          >
                            <v-card-title v-text="item.name" />
                            <v-card-subtitle v-html="toDateWithTz(item.start) + '  to  ' + toDateWithTz(item.end, item.isMidnight)" />
                            <v-card-subtitle v-text="eventDuration(item.start, item.end, item.isMidnight)" />
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-container>
                  </template>

                  <v-card
                    flat
                    fixed
                    class="mx-auto"
                  >
                    <v-toolbar
                      dark
                      :class="[selectedEvent.type_id == availability_type ? 'yellow theme--light' : 'primary']"
                    >
                      <v-toolbar-title>
                        <input
                          v-model="selectedEvent.name"
                          solo
                          class="text-white"
                          placeholder="Event Title"
                        >
                      </v-toolbar-title>
                      <v-spacer />
                      <v-btn
                        v-if="url == 'admin' || (url != 'admin' && selectedEvent.type_id == availability_type)"
                        icon
                        @click="updateAvailability(selectedEvent)"
                      >
                        <v-icon>mdi-content-save</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="url == 'admin' || (url != 'admin' && selectedEvent.type_id == availability_type)"
                        icon
                        @click="deleteAvailability(selectedEvent)"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <v-spacer class="mb-6" />
                    <v-card-text v-if="selectedEvent">
                      <v-datetime-picker
                        v-model="selectedEvent.startTime"
                        :disabled="url != 'admin' && selectedEvent.type_id == appointment_type"
                        label="Select Start Time *"
                      />
                      <v-datetime-picker
                        v-model="selectedEvent.endTime"
                        :disabled="url != 'admin' && selectedEvent.type_id == appointment_type"
                        label="Select End Time *"
                      />

                      <v-list dense>
                        <v-list-item
                          v-if="selectedEvent.meeting"
                          class="p-0"
                        >
                          <v-list-item-subtitle>{{ selectedEvent.meeting.meeting_provider_label }} meeting</v-list-item-subtitle>
                          <v-list-item-title>
                            <v-btn
                              text
                              small
                              target="_blank"
                              color="primary"
                              :href="selectedEvent.meeting.effective_join_url"
                            >
                              Join
                            </v-btn>
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="selectedEvent.meeting"
                          class="p-0"
                        >
                          <v-list-item-subtitle>Meeting starts at</v-list-item-subtitle>
                          <v-list-item-title v-html="toDateWithTz(selectedEvent.meeting.start_time)" />
                        </v-list-item>
                        <v-list-item
                          v-if="selectedEvent.meeting"
                          class="p-0"
                        >
                          <v-list-item-subtitle>Auto-Recording:</v-list-item-subtitle>
                          <v-list-item-title>
                            {{ selectedEvent.meeting.auto_recording ? "ON" : "OFF" }}
                          </v-list-item-title>
                        </v-list-item>
                        <input
                          v-model="selectedEvent.assignment_id"
                          type="hidden"
                        >
                      </v-list>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn
                        text
                        color="secondary"
                        @click="closeEventSummary"
                      >
                        Close
                      </v-btn>
                      <div v-if="url == 'admin' && selectedEvent.type_id == availability_type">
                        <v-btn
                          text
                          color="primary"
                          :disabled="isSelectedEventInPast"
                          @click="previewMeetingInviteEmail(selectedEvent)"
                        >
                          Add Appointment
                        </v-btn>
                      </div>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-tab-item>
            </v-tabs>
          </v-col>
        </v-col>

        <v-col
          cols="12"
          lg="9"
          class="vuetify-cal"
        >
          <v-sheet height="64">
            <v-toolbar
              flat
              color="white"
              offset-overflow="false"
            >
              <v-row class="btn-left-margin">
                <v-col
                  xs="12"
                  sm="5"
                  md="5"
                  class="toolbar-col col-12"
                >
                  <v-btn
                    outlined
                    color="grey darken-2"
                    @click="setToday"
                  >
                    Today
                  </v-btn>
                  <v-btn
                    fab
                    text
                    small
                    color="grey darken-2"
                    @click="prev"
                  >
                    <v-icon small>
                      mdi-chevron-left
                    </v-icon>
                  </v-btn>
                  <v-btn
                    fab
                    text
                    small
                    color="grey darken-2"
                    @click="next"
                  >
                    <v-icon small>
                      mdi-chevron-right
                    </v-icon>
                  </v-btn>
                  <span
                    v-if="$refs.calendar"
                    class="cal-title"
                  >{{ $refs.calendar.title }}</span>
                </v-col>

                <v-col
                  xs="12"
                  sm="7"
                  md="7"
                  class="d-flex  justify-content-end toolbar-col col-12"
                >
                  <span class="cal-title align-self-center me-4">{{ userTimezoneText }}</span>
                  <v-btn
                    icon
                    dark
                    class="toolbar-margin"
                    color="grey darken-2"
                    @click="confirmTimezoneDialog = true"
                  >
                    <span class="material-icons">settings</span>
                  </v-btn>
                  <v-menu
                    bottom
                    right
                  >
                    <template #activator="{ on, attrs }">
                      <v-btn
                        outlined
                        color="grey darken-2"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <span>{{ typeToLabel[type] }}</span>
                        <v-icon right>
                          mdi-menu-down
                        </v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="type = 'day'">
                        <v-list-item-title>Day</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="type = 'week'">
                        <v-list-item-title>Week</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="type = 'month'">
                        <v-list-item-title>Month</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="type = '4day'">
                        <v-list-item-title>4 days</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-col>
              </v-row>
            </v-toolbar>
          </v-sheet>
          <v-sheet>
            <v-calendar
              ref="calendar"
              v-model="focus"
              color="primary"
              :events="eventsComputed"
              :type="type"
              :event-ripple="true"
              :event-color="getEventColor"
              :event-text-color="getEventTextColor"
              @click:event="showEvent"
              @click:more="viewDay"
              @click:date="viewDay"
              @mousedown:event="startDrag"
              @mousedown:time="startTime"
              @mousemove:time="mouseMove"
              @mouseup:time="endDrag"
              @mouseleave.native="cancelDrag"
            >
              <template #event="{ event, timed }">
                <div
                  class="v-event-draggable"
                  v-html="eventSummary(event)"
                />
                <div
                  v-if="timed"
                  class="v-event-drag-bottom"
                  @mousedown.stop="extendBottom(event)"
                />
              </template>
              <template #day-body="{ date, week, present }">
                <div
                  v-if="present"
                  class="v-current-time first"
                  :style="{ top: nowY }"
                />
              </template>
            </v-calendar>
            <v-menu
              v-model="selectedOpen"
              :close-on-content-click="false"
              :activator="selectedElement"
              offset-x
              min-width="340px"
            >
              <v-card
                color="white"
                min-width="350px"
                flat
              >
                <v-toolbar
                  dark
                  :class="[selectedEvent.type_id == availability_type ? 'yellow theme--light' : 'primary']"
                >
                  <input
                    v-model="selectedEvent.name"
                    solo
                    class="text-white"
                    placeholder="Event Title"
                    style="width:100%"
                  >
                  <v-spacer />
                  <v-btn
                    v-if="false"
                    v-if0="url == 'admin' || (url != 'admin' && selectedEvent.type_id == availability_type)"
                    icon
                    @click="updateAvailability(selectedEvent)"
                  >
                    <v-icon>mdi-content-save</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="selectedEvent.type_id == availability_type && (url == 'admin' || (url != 'admin' && selectedEvent.type_id == availability_type))"
                    icon
                    @click="deleteAvailability(selectedEvent)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-toolbar>
                <v-card-text v-if="selectedEvent">
                  <v-list dense>
                    <v-list-item v-if="selectedEvent.meeting">
                      <v-list-item-subtitle>{{ selectedEvent.meeting.meeting_provider_label }} meeting</v-list-item-subtitle>
                      <v-list-item-title>
                        <v-btn
                          text
                          small
                          target="_blank"
                          color="primary"
                          :href="selectedEvent.meeting.effective_join_url"
                        >
                          Join
                        </v-btn>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="selectedEvent.meeting">
                      <v-list-item-subtitle>Meeting starts at</v-list-item-subtitle>
                      <v-list-item-title v-html="toDateWithTz(selectedEvent.meeting.start_time)" />
                    </v-list-item>
                    <v-list-item v-if="selectedEvent.meeting">
                      <v-list-item-subtitle>Auto-Recording:</v-list-item-subtitle>
                      <v-list-item-title>
                        {{ selectedEvent.meeting.auto_recording ? "ON" : "OFF" }}
                      </v-list-item-title>
                    </v-list-item>
                    <input
                      v-model="selectedEvent.assignment_id"
                      type="hidden"
                    >
                    <input
                      v-model="selectedEvent.start"
                      type="hidden"
                    >
                    <input
                      v-model="selectedEvent.end"
                      type="hidden"
                    >
                  </v-list>
                </v-card-text>
                <v-card-actions style="justify-content: space-between;">
                  <v-btn
                    text
                    color="secondary"
                    @click="selectedOpen = false"
                  >
                    Close
                  </v-btn>
                  <div v-if="url == 'admin' && selectedEvent.type_id != appointment_type">
                    <v-btn
                      text
                      color="primary"
                      :disabled="isSelectedEventInPast"
                      @click="previewMeetingInviteEmail(selectedEvent)"
                    >
                      Add Appointment
                    </v-btn>
                  </div>
                  <div v-if="url == 'admin' && selectedEvent.type_id == appointment_type">
                    <v-btn
                      text
                      color="primary"
                      @click="cancelMeeting(selectedEvent)"
                    >
                      Cancel Appointment
                    </v-btn>
                  </div>
                </v-card-actions>
              </v-card>
            </v-menu>
          </v-sheet>
          <template>
            <v-row class="m-4">
              <v-dialog
                v-model="eventForm"
                persistent
                max-width="600"
                hide-overlay
              >
                <template #activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    class="float-start"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    Add Availability
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">Add Availability</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            label="Remarks *"
                            :value="'Available: ' + expertName"
                            required
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                        >
                          <v-datetime-picker
                            v-model="availability.start"
                            label="Select Start Time *"
                            dark
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                        >
                          <v-datetime-picker
                            v-model="availability.end"
                            label="Select End Time *"
                            dark
                          />
                        </v-col>
                        <v-col cols="12">
                          <small>*indicates required field</small>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="eventForm = false"
                    >
                      Close
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="availabilityFormSubmit(availability)"
                    >
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
          </template>
        </v-col>
      </v-row>
    </v-container>

    <v-row>
      <v-dialog
        v-model="confirmTimezoneDialog"
        persistent
        max-width="430"
      >
        <v-card>
          <v-card-title class="headline">
            Please confirm your time zone
          </v-card-title>
          <v-card-text class="d-flex justify-content-around">
            <v-autocomplete
              v-model="userTimezone"
              dense
              outlined
              :items="timeZone"
              item-text="1"
              item-value="0"
              hide-details="true"
              item-color="primary"
              @change="changeZone()"
            />

            <v-btn
              class="ms-2"
              icon
              @click="detectZone"
            >
              <v-icon>gps_fixed</v-icon>
            </v-btn>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              text
              color="primary"
              @click="updateUserTimezone"
            >
              Confirm
            </v-btn>
            <v-btn
              text
              color="default"
              @click="confirmTimezoneDialog = false"
            >
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-overlay
      :value="overlay"
      :absolute="'absolute'"
    >
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
    <calendar-cancel-meeting-dialog
      v-if="cancelMeetingDialog"
      :eventid="eventActiveID"
      @close="cancelMeetingDialog = false"
      @deleted="fetchAvailabilities"
    />
    <v-snackbar
      v-model="overlapSnackbar"
      color="error"
      :timeout="6000"
      bottom
      right
    >
      {{ overlapSnackbarMessage }}
      <template #action="{ attrs }">
        <v-btn text v-bind="attrs" @click="overlapSnackbar = false">Close</v-btn>
      </template>
    </v-snackbar>
    <v-snackbar
      v-model="deleteErrorSnackbar"
      color="error"
      :timeout="5000"
      bottom
      right
    >
      {{ deleteErrorSnackbarMessage }}
      <template #action="{ attrs }">
        <v-btn text v-bind="attrs" @click="deleteErrorSnackbar = false">Close</v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import moment from "moment-timezone";

const AVAILABILITY_TYPE = 1;
const APPOINTMENT_TYPE = 2;

const STAFF_TYPE = "staff";
const MANAGER_TYPE = "manager";
const EXPERT_TYPE = "expert";
const CLIENT_TYPE = "client";

export default {
  name: "VuetifyCal",
  props: ["assignmentId", "userZone", "projectTitle", "projectId", "expertName", "userId", "userType"],
  data: () => ({
    cancelMeetingDialog: false,
    eventActiveID: null,
    value: "",
    focus: new Date().toISOString().substr(0, 10),
    type: "4day",
    typeToLabel: {
      month: "Month",
      week: "Week",
      day: "Day",
      "4day": "4 Days",
    },
    availability: {
      start: "",
      end: "",
      name: "",
      assignmentId: "",
      templateId: "",
    },
    moment: moment,
    arrayEvents: null,
    oldEvent: null,
    dragEvent: null,
    createEvent: null,
    createStart: null,
    extendOriginal: null,
    selectedEvent: {},
    tab: null,
    tabs: ["Appointments", "Availabilities"],
    eventForm: false,
    selectedElement: null,
    selectedOpen: false,
    selectedOpenSummary: false,
    new: false,
    id: "",
    url: "",
    color: "cyan",
    overlay: false,
    overlapSnackbar: false,
    overlapSnackbarMessage: '',
    deleteErrorSnackbar: false,
    deleteErrorSnackbarMessage: '',
    confirmTimezoneDialog: false,
    userTimezoneText: "",
    availability_type: AVAILABILITY_TYPE,
    appointment_type: APPOINTMENT_TYPE,
    aType: APPOINTMENT_TYPE,
    staff_type: STAFF_TYPE,
    manager_type: MANAGER_TYPE,
    expert_type: EXPERT_TYPE,
    client_type: CLIENT_TYPE,
    ready: false,
  }),
  computed: {
    ...mapState({
      events: state => state.events.events,
      timeZone: state => state.events.timeZones,
    }),
    ...mapGetters({
      events: "events/events",
      clientAvalabilities: "client/avalabilities",
    }),
    eventsComputed() {
      return [...this.$store.state.events.events, ...this.$store.state.client.avalabilities];
    },
    userTimezone: {
      get() {
        return this.$store.state.events.userTimezone;
      },
      set(value) {
        this.$store.commit("events/setUserTimezone", value);
      },
    },
    cal() {
      return this.ready ? this.$refs.calendar : null;
    },
    isSelectedEventInPast() {
      if (!this.selectedEvent || !this.selectedEvent.start) return false;
      const startMs = typeof this.selectedEvent.start === 'number'
        ? this.selectedEvent.start
        : new Date(this.selectedEvent.start).getTime();
      return this.isPastTime(startMs);
    },
    nowY() {
      let position = "-10px";
      if (this.cal) {
        let currentTime = this.updateTimeUsingZone();
        position = this.cal.timeToY(currentTime) + "px";
      }
      return position;
    },
    sideEventsComputed() {
      const d = new Date();
      d.setDate(d.getDate() - 1);
      const ret = this.events.filter(event => {
        if (event.type_id == this.aType) {
          if (event.start > d.getTime()) {
            return true;
          }
        }
      });
      return ret.sort((a, b) => a.start - b.start);
    },
  },
  watch: {
    userTimezone(value) {
      this.userTimezoneText = this.getTimezoneText(value);
    },
    timeZone() {
      this.userTimezoneText = this.getTimezoneText(this.userTimezone);
    },
    '$store.state.events.overlapError'(message) {
      if (message) {
        this.overlapSnackbarMessage = message;
        this.overlapSnackbar = true;
        this.$store.commit('events/clearOverlapError');
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    },
    '$store.state.events.deleteError'(message) {
      if (message) {
        this.deleteErrorSnackbarMessage = message;
        this.deleteErrorSnackbar = true;
        this.$store.commit('events/clearDeleteError');
        setTimeout(() => {
          this.deleteErrorSnackbar = false;
          window.location.reload();
        }, 5000);
      }
    },
  },
  mounted() {
    this.$store.dispatch("events/getTimeZones");
    if (this.userZone) {
      this.$store.commit("events/setUserTimezone", this.userZone);
    } else {
      this.detectZone();
    }
    this.fetchAvailabilities();
    this.availability.name = "Available: " + this.expertName;
    this.availability.start = moment().format("YYYY-MM-DD HH:mm:ss");
    this.availability.end = moment().format("YYYY-MM-DD HH:mm:ss");

    this.ready = true;
    this.scrollToTime();
    this.updateTime();
    if (this.userType == EXPERT_TYPE) {
      this.confirmTimezone();
    }
    this.fetchClientAvailabilities();
  },
  methods: {
    fetchAvailabilities() {
      if (this.assignmentId) {
        this.availability.assignmentId = this.assignmentId;
      } else {
        let url = window.location.pathname;
        this.url = url.substring(1, 6);
        this.availability.assignmentId = url.substring(url.lastIndexOf("/") + 1);
      }

      this.$store.dispatch("events/getEvents", {
        id: this.availability.assignmentId,
        zone: this.userTimezone,
        expertName: this.expertName,
        projectTitle: this.projectTitle,
      });
    },
    fetchClientAvailabilities() {
      let assignmentId = null;
      if (this.assignmentId) {
        assignmentId = this.assignmentId;
      } else {
        let url = window.location.pathname;
        this.url = url.substring(1, 6);
        assignmentId = url.substring(url.lastIndexOf("/") + 1);
      }
      this.$store.dispatch("client/getAvailabilities", {
          assignmentId:assignmentId,
          zone: this.userTimezone
      });
    },
    changeZone() {
      this.fetchAvailabilities();
      this.fetchClientAvailabilities();
    },
    detectZone() {
      this.$store.commit("events/setUserTimezone", moment.tz.guess());
      this.fetchAvailabilities();
    },
    confirmTimezone() {
      let browserTimezone = moment.tz.guess();
      let userTimezone = this.userZone;
      if (browserTimezone != userTimezone) {
        this.confirmTimezoneDialog = true;
      }
    },
    updateUserTimezone() {
      if (this.userId != undefined) {
        this.$store.dispatch("events/updateUserTimezone", {
          userId: this.userId,
          timezone: this.userTimezone,
          oldTimezone: this.userZone,
        });
        this.fetchAvailabilities();
        this.confirmTimezoneDialog = false;
      }
    },
    getTimezoneText(tz) {
      if (this.timeZone.length > 0) {
        let zone = this.timeZone.find(zone => zone[0] == tz);
        return zone[1];
      }
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      if (event.color.name) {
        const rgb = parseInt(event.color.name.substring(1), 16);
        const r = (rgb >> 16) & 0xff;
        const g = (rgb >> 8) & 0xff;
        const b = (rgb >> 0) & 0xff;

        return event === this.dragEvent ? `rgba(${r}, ${g}, ${b}, 0.7)` : event === this.createEvent ? `rgba(${r}, ${g}, ${b}, 0.7)` : event.color.name;
      } else {
        const rgb = parseInt(event.color.substring(1), 16);
        const r = (rgb >> 16) & 0xff;
        const g = (rgb >> 8) & 0xff;
        const b = (rgb >> 0) & 0xff;

        return event === this.dragEvent ? `rgba(${r}, ${g}, ${b}, 0.7)` : event === this.createEvent ? `rgba(${r}, ${g}, ${b}, 0.7)` : event.color;
      }
    },
    getEventTextColor(event) {
      return event.type_id === AVAILABILITY_TYPE ? "black" : "white";
    },
    setToday() {
      this.focus = new Date().toISOString().substr(0, 10);
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEventSummary(event) {
      const open = () => {
        this.selectedEvent = event;
        this.oldEvent = { ...event };
        this.selectedEvent.startTime = new Date(event.start);
        if (event.isMidnight && this.checkIsMidnight(event.end)) {
          this.selectedEvent.endTime = moment(event.end)
            .add(1, "minute")
            .toDate();
        } else {
          this.selectedEvent.endTime = new Date(event.end);
        }
        setTimeout(() => (this.selectedOpenSummary = true), 10);
      };

      if (this.selectedOpenSummary) {
        this.selectedOpenSummary = false;
        setTimeout(open, 10);
      } else {
        open();
      }
    },
    closeEventSummary() {
      this.selectedOpenSummary = false;
      this.selectedEvent.startTime = null;
      this.selectedEvent.endTime = null;
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.oldEvent = { ...event };
        this.selectedElement = nativeEvent.target;
        setTimeout(() => (this.selectedOpen = true), 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    // Called when the event card is clicked on.
    startDrag({ event, timed }) {
      if (event && Number(event.type_id) === AVAILABILITY_TYPE) {
        if (timed) {
          this.dragEvent = event;
          this.oldEvent = { ...event };
          this.dragTime = null;
          this.extendOriginal = null;
        }
      }
    },
    // Called when an empty space on the calendar is clicked on.
    startTime(tms) {
      const mouse = this.toTime(tms);
      if (this.dragEvent && Number(this.dragEvent.type_id) !== AVAILABILITY_TYPE) {
        return;
      }

      if (this.dragEvent && this.dragTime === null) {
        if (this.url === "admin"
            || (this.url !== "admin" && Number(this.dragEvent.type_id) === AVAILABILITY_TYPE)) {
          const start = this.dragEvent.start;
          this.dragTime = mouse - start;
        }
      } else {
        this.createStart = this.roundTime(mouse);
        if (this.isPastTime(this.createStart)) {
          return; // silently ignore clicks/drags in the past
        }
        const duration = 60; //minutes
        const eventEnd = this.createStart + duration * 60 * 1000;
        this.createEvent = {
          templateId: this.events.filter(item => item.hasOwnProperty("templateId")).length + 1,
          name: "Available: " + this.expertName,
          start: this.createStart,
          end: eventEnd,
          color: this.color,
          timed: true,
          type_id: AVAILABILITY_TYPE,
          assignmentId: this.availability.assignmentId,
        };
        this.new = true;
        this.availability.start = this.createEvent.start;
        this.availability.end = this.createEvent.end;
        this.availability.name = this.createEvent.name;
        this.availability.templateId = this.createEvent.templateId;
        this.$store.dispatch("events/setEventTemplate", this.createEvent);
      }
    },
    // Called when the bottom of the event card is clicked on.
    extendBottom(event) {
      if (event && Number(event.type_id) === AVAILABILITY_TYPE) {
        this.createEvent = event;
        this.oldEvent = { ...event };
        this.createStart = event.start;
        this.extendOriginal = event.end;
      }
    },
    // Called whenever the mouse moves.
    mouseMove(tms) {
      if (this.dragEvent && Number(this.dragEvent.type_id) !== AVAILABILITY_TYPE) {
        return;
      }
      this.$store.dispatch("events/mouseMove", { ele: this, tms })
    },
    // Called upon mouseup
    endDrag() {
      if (this.dragEvent && Number(this.dragEvent.type_id) !== AVAILABILITY_TYPE) {
        return;
      }
      if (this.new) {
        const minDurationMs = 15 * 60 * 1000; // 15 minutes minimum
        if (this.availability.end - this.availability.start < minDurationMs) {
          this.$store.dispatch("events/popEvent");
          this.new = false;
          return;
        }
        if (this.isPastTime(this.availability.start)) {
          this.$store.dispatch("events/popEvent");
          this.new = false;
          return;
        }
        if (this.overlapEvent(this.availability.start, this.availability.end)) {
          console.log("Event overlapped");
          this.$store.dispatch("events/popEvent");
        } else {
          this.createAvailability(this.availability);
        }
        this.new = false;
      } else {
        if (this.dragEvent) {
          if (this.isPastTime(this.dragEvent.start)) {
            console.log("Cannot move event to the past");
            this.$store.dispatch("events/resetEventStartEnd", {
              start: this.oldEvent.start,
              end: this.oldEvent.end,
              event: this.dragEvent,
            });
          } else if (!this.overlapEvent(this.dragEvent.start, this.dragEvent.end, this.dragEvent.id, true)) {
            this.updateAvailability(this.dragEvent);
          } else {
            console.log("Event overlapped");
            this.$store.dispatch("events/resetEventStartEnd", {
              start: this.oldEvent.start,
              end: this.oldEvent.end,
              event: this.dragEvent,
            });
          }
        } else if (this.extendOriginal) {
          if (this.isPastTime(this.createEvent.start)) {
            console.log("Cannot extend event into the past");
          } else if (!this.overlapEvent(this.createEvent.start, this.createEvent.end, this.createEvent.id, true)) {
            this.updateAvailability(this.createEvent);
          } else {
            console.log("Event overlapped");
          }
        }
      }
      this.oldEvent = null;
      this.dragTime = null;
      this.dragEvent = null;
      this.createEvent = null;
      this.createStart = null;
      this.extendOriginal = null;
      this.availability.end = null;
      this.availability.start = null;
      this.availability.name = "";
      this.availability.templateId = "";
    },
    // Called whenever mouse leaves the VuetifyCal component.
    cancelDrag() {
      if (this.createEvent) {
        if (this.extendOriginal) {
          this.$store.dispatch("events/resetEventStartEnd", {
            start: null,
            end: this.extendOriginal,
            event: this.createEvent,
          });
        } else {
          const i = this.events.indexOf(this.createEvent);
          if (i !== -1) {
            this.$store.dispatch("events/deleteEventByIndex", i);
          }
        }
      }

      if (this.dragEvent && this.overlapEvent(this.dragEvent.start, this.dragEvent.end, this.dragEvent.id, true)) {
        this.$store.dispatch("events/resetEventStartEnd", {
          start: this.oldEvent.start,
          end: this.oldEvent.end,
          event: this.dragEvent,
        });
      }

      this.createEvent = null;
      this.createStart = null;
      this.dragTime = null;
      this.dragEvent = null;
    },
    roundTime(time, down = true) {
      const roundTo = 15; // minutes
      const roundDownTime = roundTo * 60 * 1000;

      return down ? time - (time % roundDownTime) : time + (roundDownTime - (time % roundDownTime));
    },
    toTime(tms) {
      return new Date(tms.year, tms.month - 1, tms.day, tms.hour, tms.minute).getTime();
    },
    availabilityFormSubmit(availability) {
      // availability.start is a Date/string from the datetime picker (browser-local),
      // which matches the fake-local reference frame used by the calendar.
      const startMs = typeof availability.start === 'number'
        ? availability.start
        : new Date(availability.start).getTime();
      if (this.isPastTime(startMs)) {
        alert("Cannot add availability in the past.");
        return;
      }
      availability["templateId"] = this.events.filter(item => item.hasOwnProperty("templateId")).length + 1;
      availability["color"] = this.colors;
      availability["timed"] = true;
      availability["type_id"] = AVAILABILITY_TYPE;
      this.$store.dispatch("events/setEventTemplate", availability);
      this.createAvailability(availability);
      this.eventForm = false;
    },
    createAppointment(appointment) {
      this.$store.dispatch("events/changeEventType", {
        appointment: appointment,
        expertName: this.expertName,
        zone: this.userTimezone,
        projectTitle: this.projectTitle,
      });
      this.selectedOpen = false;
      this.selectedOpenSummary = false;
    },
    previewMeetingInviteEmail(appointment) {
      window.location.href = `/admin/email/online-meeting-invite/preview/${appointment.id}`;
    },
    createAvailability(availability) {
      this.$store.dispatch("events/createEvent", { availability: availability, zone: this.userTimezone });
    },
    updateAvailability(selectedEvent) {
      if (this.url === "admin" || (this.url !== "admin" && selectedEvent.type_id === AVAILABILITY_TYPE)) {
        this.$store.dispatch("events/updateEvent", {
          availability: selectedEvent,
          zone: this.userTimezone,
          expertName: this.expertName,
          oldEvent: this.oldEvent,
          projectTitle: this.projectTitle,
        });
        this.selectedOpenSummary = false;
        this.selectedOpen = false;
      }
    },
    cancelMeeting(event) {
      this.eventActiveID = event.id;
      this.cancelMeetingDialog = true;
    },
    deleteAvailability(selectedEvent) {
      const conf = confirm("Are you sure?");
      if (!conf) {
        return;
      }
      const meetingId = selectedEvent.meeting != undefined ? selectedEvent.meeting.id : null;
      this.$store.dispatch("events/deleteEvent", { eventId: selectedEvent.id, meetingId: meetingId });
      this.selectedOpen = false;
      this.selectedOpenSummary = false;
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
    rndElement(arr) {
      return arr[this.rnd(0, arr.length - 1)];
    },
    eventDuration(t1, t2, isMidnight) {
      let start = moment(t1);
      let end = isMidnight ? moment(t2).add(1, "minute") : moment(t2);

      return "Duration: " + end.diff(start, "hours") + "  hours";
    },
    toDate(unix, isMidnight = false) {
      if (isMidnight && this.checkIsMidnight(unix)) {
        return moment(unix)
          .add(1, "minute")
          .format("DD/MM/YY hh:mm A");
      }
      return moment(unix).format("DD/MM/YY hh:mm A");
    },
    toDateWithTz(dateTime) {
      let result;
      if (typeof dateTime === "number") {
        result = moment.unix(dateTime / 1000);
      } else {
        result = moment.utc(dateTime);
      }
      if (this.userTimezone) {
        return result.tz(this.userTimezone).format("DD/MM/YY hh:mm A");
      }
      return result.format("DD/MM/YY hh:mm A");
    },
    overlapEvent(st, et, event_id = null, isExist = false) {
      let result = false;
      let startMoment = moment(st);
      let endMoment = moment(et);
      this.events.every((event, index) => {
        if ((!isExist && index != this.events.length - 1) || (isExist && event.id != event_id)) {
          let eventStartMoment = moment(event.start);
          let eventEndMoment = moment(event.end);
          if (startMoment.isBefore(eventEndMoment) && endMoment.isAfter(eventStartMoment)) {
            result = true;
            return false;
          }
        }
      });

      return result;
    },
    eventSummary(event) {
      const start = moment(event.start).format("hh:mm A");
      const end = event.isMidnight && this.checkIsMidnight(event.end) ? "12:00 AM" : moment(event.end).format("hh:mm A");
      if (moment(event.end).diff(moment(event.start), "hours") != 0) {
        return `<strong>${event.name}</strong><br>${start} - ${end}`;
      } else {
        return `<strong>${event.name}</strong> ${start} - ${end}`;
      }
    },
    checkIsMidnight(time) {
      let result = false;
      if (moment(time).format("hh:mm A") == "11:59 PM") {
        result = true;
      }
      return result;
    },
    updateTimeUsingZone() {
      let nowMoment = moment().tz(this.userTimezone);
      let nowObj = this.cal.times.now;
      nowObj.hour = nowMoment.get("hour");
      nowObj.minute = nowMoment.get("minute");
      nowObj.time = nowMoment.format("HH:mm");
      return nowObj;
    },
    getCurrentTime() {
      return this.cal ? this.cal.times.now.hour * 60 + this.cal.times.now.minute : 0;
    },
    scrollToTime() {
      const time = this.getCurrentTime();
      const first = Math.max(0, time - (time % 30) - 30);
      this.cal.scrollToTime(first);
    },
    updateTime() {
      setInterval(() => this.updateTimeUsingZone(), 60 * 1000);
    },
    getTabName(name) {
      switch (name) {
        case "Appointments":
          this.aType = APPOINTMENT_TYPE;
          break;
        case "Availabilities":
          this.aType = AVAILABILITY_TYPE;
          break;
      }
    },
    getNowMs() {
      // cal.times.now is continuously updated to the current time in userTimezone
      // by updateTimeUsingZone(). Use its hour/minute to build a fake-local "now"
      // that sits in the same reference frame as stored event timestamps.
      if (this.cal && this.cal.times && this.cal.times.now) {
        const { hour, minute } = this.cal.times.now;
        const today = new Date();
        return new Date(
          today.getFullYear(), today.getMonth(), today.getDate(),
          hour, minute, 0, 0
        ).getTime();
      }
      return Date.now();
    },
    isPastTime(timestamp) {
      const nowMs = this.getNowMs();
      if (typeof timestamp === 'number') {
        // Numeric fake-local ms (event from store or drag createStart) — compare directly.
        return timestamp < nowMs;
      }
      // String/Date from datetime picker — browser-local parse matches fake-local frame.
      return new Date(timestamp).getTime() < nowMs;
    },
  }
}
</script>

<style scoped lang="scss">
.v-event-draggable {
  padding-left: 7px;
}

.v-event-timed {
  user-select: none;
  -webkit-user-select: none;
}

.v-event-drag-bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 4px;
  height: 4px;
  cursor: ns-resize;

  &::after {
    display: none;
    position: absolute;
    left: 50%;
    height: 4px;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    width: 16px;
    margin-left: -8px;
    opacity: 0.8;
    content: "";
  }

  &:hover::after {
    display: block;
  }
}

.toolbar-margin {
  margin-right: 16px;
}

::v-deep .v-select__selections {
  flex-wrap: nowrap;
}

.cal-title {
  font-size: 18px;
  font-weight: 400;
  line-height: 2rem;
}

.v-btn {
  height: 40px !important;
}

.v-current-time {
  height: 2px;
  background-color: #ea4335;
  position: absolute;
  left: -1px;
  right: 0;
  pointer-events: none;

  &.first::before {
    content: "";
    position: absolute;
    background-color: #ea4335;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-top: -5px;
    margin-left: -6.5px;
  }
}

@media only screen and (max-width: 768px) {
  .v-btn {
    font-size: x-small;
    height: 38px !important;
  }

  .row.btn-left-margin button,
  .cal-title {
    margin-bottom: 25px !important;
  }

  .spacer {
    height: 30px;
  }

  .toolbar-col {
    display: flex;
    justify-content: space-around !important;
    align-items: center;
  }
  ::v-deep .v-select__selections {
    font-size: 12px;
    line-height: 16px;
  }
}

@media only screen and (max-width: 600px) {
  .v-btn {
    height: 39px;
    min-width: 62px;
    padding: 0 5px !important;
  }

  .toolbar-col {
    justify-content: space-between !important;
    margin-bottom: -30px !important;
    @media only screen and (max-width: 420px) {
      margin-bottom: 20px !important;
      &:not(:last-of-type) {
        margin-bottom: -20px !important;
      }
    }
  }
}

.toolbar-col {
  @media only screen and (max-width: 420px) {
    margin-bottom: 20px !important;
    &:not(:last-of-type) {
      margin-bottom: -20px !important;
    }
  }
}

.v-btn {
  @media only screen and (max-width: 420px) {
    height: 39px;
    min-width: auto;
    padding: 0 5px !important;
  }
}

@media only screen and (max-width: 420px) {
  .toolbar-margin {
    margin-right: 5px;
  }
  .cal-title {
    font-size: 15px;
  }
}

@media only screen and (max-width: 350px) {
  .v-btn {
    padding: 0 4px !important;
  }

  .toolbar-col {
    padding: 10px 0;
  }
}
</style>
